import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function AboutSection() {
  const ref = useScrollAnimation<HTMLDivElement>();

  return (
    <section ref={ref} className="scroll-animate py-16 md:py-24 px-4 md:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4 text-center">
          천안 [GF골프 연습장]
        </h2>
        <div className="w-16 h-1 bg-accent mx-auto mb-8" />
        <h3 className="text-lg md:text-2xl text-gray-700 text-center mb-10 max-w-3xl mx-auto font-medium">
          "무거운 골프백 들고 엘리베이터 타지 마세요! 주차가 편한 대형 단층 연습장"
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-12">
          <div className="bg-[#F8F8F8] p-6 md:p-8 rounded-lg">
            <div className="w-14 h-14 flex items-center justify-center mb-4">
              <i className="ri-car-line text-3xl text-accent" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3">
              1층 초대형 주차장
            </h4>
            <p className="text-base text-gray-600 leading-relaxed">
              주차 스트레스 없는 넓고 쾌적한 주차 공간과 함께 전기차 충전 시설까지 완비되어 있습니다.
            </p>
          </div>

          <div className="bg-[#F8F8F8] p-6 md:p-8 rounded-lg">
            <div className="w-14 h-14 flex items-center justify-center mb-4">
              <i className="ri-home-line text-3xl text-accent" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3">
              주차 후 바로 진입하는 1층 구조
            </h4>
            <p className="text-base text-gray-600 leading-relaxed">
              무거운 골프백을 들고 힘들게 엘리베이터를 기다리거나 계단을 오르내릴 필요가 없어 방문이 더욱 편리합니다.
            </p>
          </div>

          <div className="bg-[#F8F8F8] p-6 md:p-8 rounded-lg">
            <div className="w-14 h-14 flex items-center justify-center mb-4">
              <i className="ri-layout-line text-3xl text-accent" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3">
              여유롭고 넓은 타석 간격
            </h4>
            <p className="text-base text-gray-600 leading-relaxed">
              타 연습장 대비 타석 간격을 넓게 세팅하여 주변 시선 의식 없이 쾌적하고 개방감 있는 환경에서 스크린 연습을 즐기실 수 있습니다.
            </p>
          </div>
        </div>

        <div className="text-center">
          <div className="flex items-center justify-center gap-2 text-gray-800 mb-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-phone-line text-lg" />
            </div>
            <span className="text-base font-medium">전화상담</span>
          </div>
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900">
            <a href="tel:041-578-3700" className="hover:underline">
              041-578-3700
            </a>
          </h3>
        </div>
      </div>
    </section>
  );
}